/*
 * Views for the List region of the substitutions page
 */

define(["marionette", "modules/reportSplit/groups/template/groupTemplate.html"], function (
  Marionette,
  GroupTemplate,
) {
  var GroupView = {};

  GroupView.groupLayout = Marionette.Layout.extend({
    template: GroupTemplate,
    regions: {
      groupList: "#groupList",
      groupDiv: "#groupDiv",
      workbookDiv: "#workbookDiv",
    },
    showTiles: function () {
      this.$el.find("#groupDiv").show();
      this.$el.find("#workbookDiv").hide();
    },
    hideTiles: function () {
      this.$el.find("#groupDiv").hide();
      this.$el.find("#workbookDiv").show();
    },
  });

  return GroupView;
});
